import { render, staticRenderFns } from "@/style-guide/style-guide.pug?vue&type=template&id=592d9be2&lang=pug&external"
import script from "./style-guide.view.vue?vue&type=script&lang=ts"
export * from "./style-guide.view.vue?vue&type=script&lang=ts"
import style0 from "@/style-guide/style-guide.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports